import axios from "axios";
import { apiClient } from "../../../config/apiClient";
import Config from "../../../config/config";
import {

  CREATE_MANAGE_CATEGORY_ERROR,
  CREATE_MANAGE_CATEGORY_REQUEST,
  CREATE_MANAGE_CATEGORY_SUCCESS,

  DELETE_MANAGE_CATEGORY_ERROR,
  DELETE_MANAGE_CATEGORY_REQUEST,
  DELETE_MANAGE_CATEGORY_SUCCESS,

  GET_MANAGE_CATEGORY_ERROR,
  GET_MANAGE_CATEGORY_REQUEST,
  GET_MANAGE_CATEGORY_SUCCESS,

  MANAGE_CATEGORY_SHIFT_REQUEST,

  UPDATE_MANAGE_CATEGORY_ERROR,
  UPDATE_MANAGE_CATEGORY_REQUEST,
  UPDATE_MANAGE_CATEGORY_SUCCESS,

} from "../actiontypes";
export const getCategory = ({ pageNo = 1, search = "", type = "", column_name = "" }) => {
  const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
  return async (dispatch) => {
    dispatch(getSpecialitiesRequest());
    await axios
      .get(
        `${Config.API_URL}api/organization/get-all-category?search=${search}&page=${pageNo}&type=${type}&column_name=${column_name}`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${loggedInUser}`,
          },
        }
      )
      .then((response) => {
        const dataItem = response.data;
        if (dataItem.status === true) {
          dispatch(getSpecialitiesSuccess(dataItem.data));
        } else {
          dispatch(getSpecialitiesSuccess(""));
          dispatch(getSpecialitiesError(dataItem.data));
        }
      })
      .catch((error) => {
        dispatch(getSpecialitiesSuccess(""));
        dispatch(getSpecialitiesError(error));
      });
  };
};

export const getSpecialitiesRequest = () => {
  return {
    type: GET_MANAGE_CATEGORY_REQUEST,
  };
};
export const getSpecialitiesSuccess = (data) => {
  return {
    type: GET_MANAGE_CATEGORY_SUCCESS,
    payload: data,
  };
};
export const getSpecialitiesError = (error) => {
  return {
    type: GET_MANAGE_CATEGORY_ERROR,
    payload: error,
  };
};

// -----------------------------

export const getCategoryCreate = (result) => {
  return async (dispatch) => {
    dispatch(getSpecShiftCreateRequest());
    await apiClient(true)
      .get(`api/organization/get-spec-shift-create`)
      .then((response) => {
        result(response.data);
      })
      .catch((error) => {
        result(error);
      });
  };
};

export const getSpecShiftCreateRequest = () => {
  return {
    type: MANAGE_CATEGORY_SHIFT_REQUEST,
  };
};

export const createCategory = (data) => {
  const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
  return async (dispatch) => {
    dispatch(createCategoryRequest());
    await apiClient(true)
      .post(`api/organization/add-categories`, data, {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${loggedInUser}`,
        },
      })
      .then((response) => {
        const data = response.data;
        if (data.status === true) {
          dispatch(createCandidateSuccess(data));
          setTimeout(() => {
            dispatch(getCategory(1, ""));
          }, 2000);
        } else {
          dispatch(createCategoryError(data));
        }
      })
      .catch((error) => {
        dispatch(createCategoryError(error));
      });
  };
};

export const createCategoryRequest = () => {
  return {
    type: CREATE_MANAGE_CATEGORY_REQUEST,
  };
};
export const createCandidateSuccess = (data) => {
  return {
    type: CREATE_MANAGE_CATEGORY_SUCCESS,
    payload: data,
  };
};
export const createCategoryError = (error) => {
  return {
    type: CREATE_MANAGE_CATEGORY_ERROR,
    payload: error,
  };
};

// -----------------------------------

export const updateCategory = (data) => {
  const { id, category_name, category_description, status } = data;
  const data1 = {
    id: id,
    category_name: category_name,
    category_description: category_description,
    status: status
  };
  const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
  return async (dispatch) => {
    dispatch(updateSpecialitiesRequest());
    await axios
      .post(`${Config.API_URL}api/organization/edit-categories`, data1, {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${loggedInUser}`,
        },
      })
      .then((response) => {
        const data = response.data;
        if (data.status === true) {
          dispatch(updateSpecialitiesSuccess(data));
          setTimeout(() => {
            dispatch(getCategory(1, ""));
          }, 2000);
        } else {
          dispatch(updateSpecialitiesError(data));
        }
      })
      .catch((error) => {
        dispatch(updateSpecialitiesError(error));
      });
  };
};

export const updateSpecialitiesRequest = () => {
  return {
    type: UPDATE_MANAGE_CATEGORY_REQUEST,
  };
};
export const updateSpecialitiesSuccess = (data) => {
  return {
    type: UPDATE_MANAGE_CATEGORY_SUCCESS,
    payload: data,
  };
};
export const updateSpecialitiesError = (error) => {
  return {
    type: UPDATE_MANAGE_CATEGORY_ERROR,
    payload: error,
  };
};

// -------------------------------------

export const deleteCategory = (id) => {
  const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
  return async (dispatch) => {
    dispatch(deleteSpecialitiesRequest());
    await axios
      .delete(
        `${Config.API_URL}api/organization/delete-categories/${id}`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${loggedInUser}`,
          },
        }
      )
      .then((response) => {
        const data = response.data;
        if (data.status === true) {
          dispatch(deleteSpecialitiesSuccess(data));
          setTimeout(() => {
            dispatch(getCategory(1, ""));
          }, 2000);
        } else {
          dispatch(deleteSpecialitiesError(data));
          setTimeout(() => { // extra i have added for page reload for testing purpose
            dispatch(getCategory(1, ""));
          }, 2000);
        }
      })
      .catch((error) => {
        dispatch(deleteSpecialitiesError(error));
      });
  };
};

export const deleteSpecialitiesRequest = () => {
  return {
    type: DELETE_MANAGE_CATEGORY_REQUEST,
  };
};
export const deleteSpecialitiesSuccess = (data) => {
  return {
    type: DELETE_MANAGE_CATEGORY_SUCCESS,
    payload: data,
  };
};
export const deleteSpecialitiesError = (error) => {
  return {
    type: DELETE_MANAGE_CATEGORY_ERROR,
    payload: error,
  };
};
